import { TrashIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useRolodexEdit } from 'features/fde'
import { useKestrel } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVMeasurement, RolodexEntryPatchJson } from 'types'

const StyledTrashIcon = styled(TrashIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const DeleteMeasurementButton: FC<{
  measurementId: string
}> = ({ measurementId }) => {
  const {
    sendKVCommand,
    selectedMarkup,
    setSelectedMarkup,
    kestrelModel,
    measurements,
    setMeasurements,
  } = useKestrel()
  const { rolodexPatch } = useRolodexEdit()

  const deleteMeasurement = (e: React.MouseEvent) => {
    e.stopPropagation()
    let filteredMeasurements: KVMeasurement[] = []
    if (measurements) {
      filteredMeasurements = measurements.filter((a) => a.id !== measurementId)
    }
    if (sendKVCommand) {
      setMeasurements(filteredMeasurements)
      sendKVCommand({
        command: KestrelCommands.DELETE_MEASUREMENT,
        measurementId: measurementId,
      })
      if (selectedMarkup?.id === measurementId) setSelectedMarkup(undefined)

      // Delete from Rolodex
      if (kestrelModel?.id) {
        const patchData: RolodexEntryPatchJson = {
          id: kestrelModel.id,
          data: {
            measurements:
              filteredMeasurements?.map((a) => KVMeasurement.toJSON(a)) ?? [],
          },
        }
        rolodexPatch([patchData])
      }
    }
  }

  return (
    <TooltipWrapper label='Delete measurement' side='top'>
      <div
        style={{ cursor: 'pointer', marginLeft: '-4px' }}
        onClick={(e) => deleteMeasurement(e)}>
        <StyledTrashIcon width={22} height={22} />
      </div>
    </TooltipWrapper>
  )
}
